import { useMemo, useState } from "react";
import { Box } from "@mui/material";
import { ParagraphText, UBRadioBox } from "../../../../Libraries";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import { PaymentMethodToggle } from "../../../common";
import { useWalletContext } from "../../../../context/WalletContext";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { updatedPaymentMethods, EasyloadAndPackages } from "../../../../constants";
import { CoinIcon, RechargePlaceholderIcon } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import formStyles from "../../SaleExpense/SaleExpenseForm/styles.module.css";
import styles from "../BillPayments/BillPayments.module.css";

const ReviewSection = ({
  I18n,
  detail,
  categoryList = [],
  state,
  setState,
}) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const { billType, offer } = detail;
  const { earnMoney, walletData } = useWalletContext();
  const availableTelcos = walletData?.available_telcos || [];

  const telco =
    availableTelcos.length > 0
      ? availableTelcos.find(
        (item) =>
          item.name.toLowerCase() === detail?.platform?.toLowerCase(),
      )
      : null;

  const { postpaid_commission, bundle_commission, commission } = telco || {};

  const comission =
    billType == "postpaid"
      ? postpaid_commission
      : offer
        ? bundle_commission
        : commission;
  const comissionAmount = (detail?.amount * (comission || 0)) / 100;

  const network = earnMoney.easyloadPackages.list.length
    ? earnMoney.easyloadPackages.list.find(
      (item) => item.name.toLowerCase() === detail?.platform?.toLowerCase(),
    )
    : {};

  const customerName = detail?.customerName || "";
  const customerNumber = detail?.customerNumber || "";
  const fromBundle = detail?.type?.toLowerCase() !== "easyload";


  const earningRule = telco?.earning_rule;


  const selectedEarningRule = Number(fromBundle ? earningRule?.bundle : earningRule?.recharge);
  const shouldShowPoints = earningRule != null && Number.isFinite(selectedEarningRule) && selectedEarningRule !== 0;
  const coins = shouldShowPoints ? Math.floor(selectedEarningRule * detail.amount * 10) : null;
  const categoryOptions = useMemo(
    () =>
      (categoryList || []).map((item) => ({
        id: item.id,
        labelText: item.label || item.name,
        label: (
          <ParagraphText className={formStyles.contactLabel}>
            <span className="newFontColor">{item.label || item.name}</span>
          </ParagraphText>
        ),
        value: item.label || item.name,
      })),
    [categoryList],
  );

  return (
    <Box className={styles.reviewWrapper}>
      <Box className={styles.amountCard}>
        <ParagraphText
          className={`fontSize14 newLightColor ${styles.amountLabel}`}
        >
          {I18n.amount}
        </ParagraphText>
        <Box className={styles.amountRow}>
          <ParagraphText
            className={`fontSize24 fontWeight600 newFontColor ${styles.amountValue}`}
          >
            Rs. {formatNum(detail.amount)}
          </ParagraphText>
        </Box>

        <Box className={styles.billDetailRow}>
          {network?.logo ? (
            <Box className={styles.billDetailIconWrapper}>
              {!logoFailed ? (
                <img
                  src={network.logo}
                  alt=""
                  className={styles.billDetailIcon}
                  onError={() => setLogoFailed(true)}
                />
              ) : (
                <RechargePlaceholderIcon width={19} height={19} />
              )}
            </Box>
          ) : null}
          <Box className={styles.billDetailText}>
            {customerName ? (
              <ParagraphText className="fontSize14 newFontColor">
                {customerName}
              </ParagraphText>
            ) : null}
            {customerNumber ? (
              <ParagraphText className="fontSize14 newLightColor">
                {customerNumber}
              </ParagraphText>
            ) : null}
          </Box>
          {offer?.offer_name ? (
            <ParagraphText
              className={`fontSize14 newLightColor ${styles.dueDate}`}
            >
              {offer.offer_name}
            </ParagraphText>
          ) : null}
        </Box>

        <Box className={styles.earnPointsRow}>
          <CoinIcon />
          <ParagraphText className="fontSize12">
            <span className="newFontColor">{`Rs. ${comissionAmount}`} {shouldShowPoints ? "+" : ""} </span>
            {shouldShowPoints && <span className="mustardYellowShadeColor">({coins} {I18n.points})</span>}
          </ParagraphText>
        </Box>
      </Box>

      <Box className={styles.reviewFields}>
        <Box className={`${formStyles.tabAutoCompleteBox} tabAutoCompleteBox`}>
          <TabAutoComplete
            id="easyload_review_category"
            list={categoryOptions}
            label={I18n.select_category}
            handleSelect={(item) => {
              triggerLogEvent(
                analytics,
                detail?.type === EasyloadAndPackages.EASYLOAD
                  ? "w_earn_ep_easyload_category"
                  : "w_earn_ep_packages_category",
              );
              setState((e) => ({
                ...e,
                rechargeCategory: item?.labelText || item?.value || "",
                rechargeCategoryId: item?.id || "",
              }));
            }}
            value={state?.rechargeCategory || ""}
            placeholder={I18n.select_category}
            handleStartLogEvent={() => { }}
            manuallyFocusInput={false}
            handleManuallyInput={() => { }}
          />
        </Box>

        <Box
          className={`paymentStatusBoxWrapper ${formStyles.paymentStatusBoxWrapper}`}
        >
          <Box className={formStyles.paymentStatusBox}>
            <Box className={formStyles.paymentStatusBoxLeft}>
              <UBRadioBox
                label={"Paid"}
                displayLabel={I18n.paid}
                onChange={(value) => {
                  setState((e) => {
                    const next = { ...e, paymentStatus: value };
                    if (!e.paymentMode) {
                      next.paymentMode =
                        updatedPaymentMethods.find((m) => m.name === "bank")
                          ?.display_name || "Bank";
                    }
                    return next;
                  });
                }}
                value={state.paymentStatus}
              />
              <UBRadioBox
                label={"Unpaid"}
                displayLabel={I18n.unpaid}
                onChange={(value) => {
                  setState((e) => ({ ...e, paymentStatus: value }));
                }}
                value={state.paymentStatus}
              />
            </Box>
            <Box className={formStyles.paymentStatusBoxRight}>
              <PaymentMethodToggle
                idPrefix="easyload_review_payment_method"
                visible={
                  (state.paymentStatus || "").toLocaleLowerCase() === "paid"
                }
                value={(state.paymentMode || "").toLowerCase() || null}
                onChange={(method) => {
                  setState((e) => ({
                    ...e,
                    paymentMode:
                      method?.display_name || method?.name || "Bank",
                  }));
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ReviewSection;
